import React from 'react';
import { Button, Space, Form, message, Row, Col, Input, Alert, Modal } from 'antd';
import { OrderModel } from '@app/interfaces/order';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { updateStatusOrder } from '@app/store/slices/orderSlice';
import { MdCancel } from "react-icons/md";

interface CancelOrderFormProps {
  open: boolean;
  record?: OrderModel;
  onClose: () => void;
}

const CancelOrderForm: React.FC<CancelOrderFormProps> = ({open, record, onClose}) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      dispatch(updateStatusOrder({
        orderId: Number(record?.id),
        formData: {
          status_id: 8, //status canceled
          reason: values.reason,
        },
      }));

      onClose();

    } catch (error: any) {
      if (error instanceof Error) {
        message.error(error.message);
      } else {
        message.error('An unknown error occurred');
      }
    }
  };

  const description = `Bạn có chắc huỷ đơn ${record?.order_code}?`

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        style={{ top: 20 }}
        closable={true}
        footer={null}
      >
        <h3 className="mb-4"><span className="font-bold-weight">Huỷ đơn hàng!</span></h3>

        <Alert
          description={description}
          type="error" banner closable
          className="text-danger my-3"
        />
     
        <Form
          form={form}
          name="form-order"
          className="order-container"
          initialValues={{
            group_code: [record?.order_code]
          }}
        >
          <Row>
            <Col span={5}>
              Lý do huỷ
            </Col>
            <Col span={19}>
              <Form.Item name="reason" rules={[{ required: true, message: 'Please input reason!' }]}>
                <Input.TextArea showCount maxLength={100} placeholder="Comment here..." />
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-4 text-right">
            <Col span={24}>
              <Space>
                <Button type="primary" danger onClick={handleSubmit}><MdCancel /> Thực hiện</Button>
                <Button type="primary" onClick={onClose}>Quay lại</Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default CancelOrderForm;